import React, { useContext } from "react"
import { Text, View } from "react-native"
import { numberFormat } from "@ecountabl/lib"
import { textStyles } from "../../style"
import { ThemeContext } from "../../utility/context/ThemeContext"
import useScreenSize from "../../utility/screen-size"
import ValueLabelCard from "../../utility/value-label-card"
import { EnvironmentalImpactChart } from "./environmental-impact-chart"
import type { CustomerSavingsImpactType } from "./types"

type EnvironmentalImpactSectionProps = {
  customerSavingsImpact: CustomerSavingsImpactType
}

export const EnvironmentalImpactSection = ({
  customerSavingsImpact,
}: EnvironmentalImpactSectionProps): JSX.Element => {
  const theme = useContext(ThemeContext)
  const { second, textMain } = theme.theme.colors
  const equivalents = Object.keys(customerSavingsImpact.EquivalentsWithIcons || {})
  const { width } = useScreenSize()
  const isSingleColumnEquivalencies = width <= 430

  return (
    <>
      <Text style={[textStyles.h3, { color: textMain }]}>Environmental Impact</Text>
      <EnvironmentalImpactChart data={customerSavingsImpact["Solar"] || []} />
      {
        equivalents?.length > 0 ? (
        <View style={{ paddingHorizontal: 10, width: "100%" }}>
          <Text style={[textStyles.body, { color: second }]}>This is equivalent to...</Text>
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: isSingleColumnEquivalencies ? "center" : "space-evenly",
              alignItems: "stretch",
              marginVertical: 5,
              gap: 12,
            }}
          >
            {
              equivalents.map((eq) => {
                const entry = customerSavingsImpact.EquivalentsWithIcons[eq]
                if (!entry) return null

                const iconRaw = typeof entry.icon === "string" ? entry.icon : ""
                const [iconFamily = "", iconName = ""] = iconRaw.split("::")
                const numericValue = Number(entry.value ?? 0)
                const value = numberFormat(
                  Number.isFinite(numericValue) ? numericValue : 0,
                  { shortenLargeNumbers: true }
                )

                return (
                  <ValueLabelCard
                    key={eq}
                    label={eq}
                    value={value}
                    icon={{ family: iconFamily, name: iconName }}
                    containerStyle={{
                      minWidth: isSingleColumnEquivalencies ? 0 : 250,
                      maxWidth: 300,
                      flexBasis: isSingleColumnEquivalencies ? "100%" : 250,
                      flexGrow: isSingleColumnEquivalencies ? 0 : 1,
                      width: isSingleColumnEquivalencies ? "100%" : undefined,
                    }}
                  />
                )
              })
            }
          </View>
        </View>
        ) : null
      }
    </>
  )
}
